const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export default (dt) => {
  const date = new Date(dt).getDate();
  const month = shortMonths[new Date(dt).getMonth()];
  const year = new Date(dt).getFullYear();
  return `${month}${year}${date}`;
};
